import apiAuctions from '../../api/apiAuctions'

const state = {
    status: false,
    result: [],
    query: {
        brand: '',
        'models': [],
        'grades': [],
        yearMin: 2006,
        yearMax: new Date().getFullYear(),
        kmsMin: null,
        kmsMax: null,
        priceMin: null,
        priceMax: null,
        ccMin: null,
        ccMax: null,
        date: null,
        'dates': [],
        carGrade: null,
        'chassis': [],
        'transmissions': [],
        'lots': [],
        'colors': [],
        'equipment': [],
        'auctions': [],
        'regions' : [],
        order_column: 'AUCTION_DATE',
        order_type: 'DESC',
        limit_start: 0,
        limit_end: 30,
    }
}

const getters = {
    getStatsStatus: (state) => {
        return state.status
    },
    getStatsQuery: (state) => {
        return state.query
    },
    getStatsResult: (state) => {
        return state.result
    }
}

const mutations = {
    updateStatsStatus: (state, value) => {
        state.status = value
    },
    updateStatsQueryField: (state, input) => {
        state.query[input.field] = input.value
    },
    pushStatsResult: (state, value) => {
        state.result = state.result.concat(value)
    },
    updateStatsResult: (state, value) => {
        state.result = value
    },
    updateStatsQuery: (state, query) => {
        const notAllowed = ['order_column', 'order_type', 'page', 'auctionType'];

        Object.keys(query)
            .filter(key => notAllowed.includes(key))
            .forEach(key => delete query[key])


        for (const [key, value] of Object.entries(query)) {
            state.query[key] = value
        }
        
    }
}

const actions = {
    setStatsStatus: ({ commit }, value) => {
        commit('updateStatsStatus', value)
    },
    setStatsQueryFieldValue: ({ commit }, value) => {
        commit('updateStatsQueryField', value)
    },
    fetchStatsResult: ({commit, state, dispatch}) => {
        dispatch('setSearchResultsLoadingStatus', true)
        apiAuctions
            .getPastResult(state.query)
            .then((response) => {
                console.log(response.data)
                commit('updateStatsResult', response.data.results)
                dispatch('setAdvanceSearchResultTotalLotsNumber', response.data.totalNumber[0].TAG0)
                dispatch('setSearchResultsLoadingStatus', false)
            })
            .catch((error) => {
                dispatch('setSearchResultsLoadingStatus', false)
                console.log(error)
            })
    },
    loadMoreStatsResults: ({ commit, state }) => {
        commit('updateStatsQueryField', { field: 'limit_start', value: state.query.limit_start + 30 })
        commit('updateStatsQueryField', { field: 'limit_end', value: state.query.limit_end + 30 })
        apiAuctions
            .getPastResult(state.query)
            .then((response) => {
                commit('pushStatsResult', response.data.results)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    mergeStatsQueryWithSearch: ({ commit }, value) => {
        commit('updateStatsQuery', value)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics.js